import './vendor';
import {
  enableProdMode,
  ErrorHandler,
  isDevMode,
  provideBrowserGlobalErrorListeners,
  provideCheckNoChangesConfig
} from '@angular/core';
import moment from 'moment';

import { environment } from './environments/environment';
import { HttpErrorHandler } from './app/http-error-handler.service';
import { jwtInterceptor } from './app/auth/jwt.interceptor';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { provideSweetAlert2 } from '@sweetalert2/ngx-sweetalert2';
import { AppComponent } from './app/app.component';
import { provideIcons } from './app/icons';
import { routes } from './app/routes/routes';
import { bootstrapApplication } from '@angular/platform-browser';

moment.locale('fr');

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    { provide: ErrorHandler, useClass: HttpErrorHandler },
    ...(isDevMode()
      ? [provideCheckNoChangesConfig({ exhaustive: true, interval: 1000 })]
      : []),
    provideBrowserGlobalErrorListeners(),
    provideHttpClient(withInterceptors([jwtInterceptor])),
    provideIcons(),
    provideRouter(routes),
    provideSweetAlert2()
  ]
}).catch(err => console.error(err));
